export enum TrainingPlanStatusEnum {
  Draft = 'Draft',
  Submitted = 'Submitted',
  ContentApproval = 'ContentApproval',
  ReadyForAssignment = 'ReadyForAssignment',
  Retire = 'Retire',
}
